
import { ReactComponent as Icon } from '../../assets/images/svg/about-us.svg'
import { Helmet } from 'react-helmet-async'

const About = () => {
  return (
    <div className='About' id='aboutus'>
      <Helmet>
        <title>About Us | NEOVERA SURVEYING CORPORATION</title>
        <meta
          name="description"
          content="NEOVERA SURVEYING CORPORATION delivers reliable surveying and inspection services, specializing in mineral ores such as nickel, iron, copper, chromite, and manganese."
        />
        <link rel="canonical" href="https://neoveracsc.com/#aboutus" />
      </Helmet>

      <div className='About__container'>
        <div className='About__item'>
          <h2 className='headingH2'>
            <Icon className='icon' />
            About Us
          </h2>
          <div className='About__item--content'>
            <p>
              NEOVERA SURVEYING CORPORATION is dedicated to providing reliable and high quality surveying services. With a team of highly skilled surveyors and inspectors, supported by licensed chemical engineers and chemists, we ensure precise sampling and testing of mineral ores such as nickel, iron, copper, chromite, and manganese. Our commitment to accuracy and professionalism enables us to deliver trusted results to our clients in the mining and trade industry.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default About
